module.exports = __webpack_public_path__ + "static/media/knife-kitchen.ec58e727.svg";